if (!customElements.get("testimonials-component")) {
  class Testimonials extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: ".testimonials__items",
        pagination: ".swiper-pagination",
        nextEl: ".swiper-btn-next",
        prevEl: ".swiper-btn-prev",
        scrollbar: ".swiper-scrollbar",
      };
      this.classes = {
        grid: "f-grid",
        swiper: "swiper",
        swiperWrapper: "swiper-wrapper",
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = parseFloat(this.dataset.items);
      this.tabletItems = parseFloat(this.dataset.tabletItems);
      this.tabletLargeItems = parseFloat(this.dataset.tabletLargeItems);
      this.mobileItems = parseFloat(this.dataset.mobileItems);

      this.sliderInstance = false;

      if (!this.enableSlider) return;

      this.init();
      document.addEventListener("matchMobile", () => {
        this.init();
      });
      document.addEventListener("unmatchMobile", () => {
        this.init();
      });
    }

    init() {
      this.initSlider();
    }

    initSlider() {
      const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);
      const sliderOptions = {
        slidesPerView: this.mobileItems,
        spaceBetween: columnGap.mobile,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: false,
        scrollbar: {
          el: this.section.querySelector(this.selectors.scrollbar),
          draggable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: this.tabletItems,
            spaceBetween: columnGap.tablet,
          },
          1024: {
            slidesPerView: this.tabletLargeItems,
            spaceBetween: columnGap.tabletLarge,
          },
          1280: {
            slidesPerView: this.items,
            spaceBetween: columnGap.desktop,
          },
        },
        loop: false,
        threshold: 2,
      };

      if (typeof this.sliderInstance !== "object" && !this._swiperLoading) {
        this._swiperLoading = true;
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        FoxTheme.loadSwiper().then((Swiper) => {
          this._swiperLoading = false;
          this.sliderInstance = new Swiper(this, sliderOptions);

          const focusableElements = FoxTheme.a11y.getFocusableElements(this);

          focusableElements.forEach((element) => {
            element.addEventListener("focusin", () => {
              const slide = element.closest(".swiper-slide");
              this.sliderInstance.slider.slideTo(
                this.sliderInstance.slider.slides.indexOf(slide)
              );
            });
          });
        });
      }
      if (Shopify.designMode && typeof this.sliderInstance === "object") {
        document.addEventListener("shopify:block:select", (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          let { target } = e;
          const index = Number(target.dataset.index);

          this.sliderInstance.slider.slideToLoop(index);
        });
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance === "object") {
        this.sliderInstance.destroy();
        this.sliderInstance = false;
      }
    }
  }
  customElements.define("testimonials-component", Testimonials);
}
